module.exports = __webpack_public_path__ + "static/media/yuda.8a7b3b2f.png";